import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    /** 新增会员信息 **/
    ADD_MEMBER(data) {
        controller='Member';
        action='AdMember';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取会员信息 **/
    GET_MEMBER_INFO(data) {
        controller='Member';
        action='GetMemberList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除会员信息 **/
    DEL_MEMBER(data) {
        controller='Member';
        action='DelMember';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 批量编辑会员信息 **/
    EDIT_MEMBER(data) {
        controller='Member';
        action='EditMember';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

}